export type EmailQuoteOrInvoiceProps = {
  quote: {
    customer_id: number;
    id: number;
    job_id: number;
    links: {
      quote_email: string;
      quote_email_template: string; // template no customizations populated
      quote_email_preview: string;
    };
  };
  invoice: {
    customer: {
      customer_id: number;
    };
    invoice_id: number;
    job_id: number;
    links: {
      invoice_email: string;
      invoice_email_template: string; // template no customizations populated
      invoice_email_preview: string;
    };
  };
};

export class EmailRecipient {
  name = "";
  email_address = "";
  primary = false;
  owner = "Customer" as "Customer" | "Address";
  checked = true;

  constructor(params: Partial<EmailRecipient> = {}) {
    Object.assign(this, params);
  }
}
